import { render, staticRenderFns } from "./ActiveAdvisorySchools.vue?vue&type=template&id=542adc25&scoped=true"
import script from "./ActiveAdvisorySchools.vue?vue&type=script&lang=js"
export * from "./ActiveAdvisorySchools.vue?vue&type=script&lang=js"
import style0 from "./ActiveAdvisorySchools.vue?vue&type=style&index=0&id=542adc25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542adc25",
  null
  
)

export default component.exports